export const columns = function() {
  return [
    {
      prop: 'dictName',
      label: '名称',
      minWidth: 150
    },
    {
      prop: 'dictTypeName',
      label: '类别',
      minWidth: 150
    },
    {
      prop: 'dictValue',
      label: '数据',
      minWidth: 150
    },
    {
      prop: 'remark',
      label: '备注',
    },
    {
      prop: 'handle',
      label: '操作',
    }
  ]
}

export const classColumns = function() {
  return [
    {
      prop: 'typeName',
      label: '名称',
      minWidth: 150,
      slotName: 'name'
    },
    {
      prop: 'custom',
      label: '操作',
      slotName: 'custom'
    },
  ]
}

/**
 * 表单相关
 */
// 添加字典option
export const dictFormOption = function() {
  return [
    {
      prop: 'dictName',
      label: '字典名称',
      type: 'input',
      placeholder: '请输入字典名称'
    },
    
    {
      prop: 'dictType',
      label: '字典类别',
      type: 'select',
      options: this.classOptions
    },
    {
      prop: 'dictValue',
      label: '字典数据',
      type: 'input',
      placeholder: '请输入字典数据'
    },
    {
      prop: 'remark',
      label: '备注',
      type: 'textarea',
      placeholder: '请输入内容'
    },
  ]
}
// 搜索字典
export const searchOption = function() {
  return [
    {
      prop: 'dictType',
      label: '类别',
      type: 'select',
      options: this.classOptions,
      labelWidth: '60',
      width: '18%'
    },
  ]
} 

/**
 * 校验相关 
 */
export const rules = function(self) {
  console.log(self)
  return {
    dictName: [
      { required: true, message: '请输入字典名称', trigger: ['change', 'blur']}
    ],
    dictType: [
      { required: true, message: '请输入字典类别', trigger: ['change', 'blur']}
    ],
    
  }
}


export default {}